import React, {useEffect} from 'react'
import NextVideo from './nextVideo/NextVideo'
import WatchingVideoLeft from './watchingVideo_left/WatchingVideoLeft.jsx'
import WatchingVideoLeftBot from './watchingVideo_left/wVideo_left_bot/WVideoLeftBot';
import { Link, useParams } from "react-router-dom";
import {  useMutation, useQuery } from '@apollo/client';
import { VIDEOS_WATCHED } from '../../graphql-client/Queries';
import { GET_AVATAR_USER_MANAGE, USER_PACKAGES_OF_YEAR } from '../../graphql-client/Queries';
import {CREATED_VIEW} from '../../graphql-client/Mutation'
export default function WatchingVideo() {
    let {id} = useParams();
    
    const { data: data2, loading: loading2 } = useQuery(GET_AVATAR_USER_MANAGE);
    //TÌM THÔNG TIN KHÓA HỌC NĂM MÀ NGƯỜI DÙNG ĐANG KÝ(kiểm tra thời hạn hết hạn gói cước năm và sự kích hoạt gói cước chưa)
    const { data: data3, loading: loading3 } = useQuery(USER_PACKAGES_OF_YEAR, {
        variables: { userId: data2?.userManage?.id }
    });

    const [createView] = useMutation(CREATED_VIEW,{
      variables:{
        videoId: id
      },
      update: (cache, { data }) => {
        try {
          if (!data?.updateVideoView?.newView) return;

          const newView = data.updateVideoView.newView;
          
          // Đọc cache hiện tại của VIDEOS_WATCHED
          const existingData = cache.readQuery({
            query: VIDEOS_WATCHED,
            variables: { take: 12 }
          });

          if (existingData) {
            // Thêm video mới vào đầu danh sách
            const updatedVideosWatched = [newView, ...existingData.videosWatched];

            // Ghi lại vào cache
            cache.writeQuery({
              query: VIDEOS_WATCHED,
              variables: { take: 12 },
              data: {
                videosWatched: updatedVideosWatched
              }
            });
          }
        } catch (error) {
          // Nếu cache chưa có data thì bỏ qua
          console.log('Cache update skipped:', error);
        }
      }
    })

    useEffect(() => {
      createView()
    }, [createView])
    
    if(loading2) return <p>loading...</p>;
    if(loading3) return <p>loading...</p>; 
    //thời gian xem còn lại trong tháng bằng tổng thời gian đã mua gói năm và thời gian mua trong tháng hoặc miễn phí trong tháng
    // cần kiểm tra thời hạn hết hạn gói cước năm và sự kích hoạt gói cước chưa
    const isMonthlyWatchTime = 
    data3?.userPackagesOfYear && data3.userPackagesOfYear.length > 0
      ? (data2?.userManage?.monthlyWatchTime || 0) + (data2?.userManage?.extraWatchTime || 0) //thời gian xem video trong tháng còn lại là tổng thời gian gói cước tháng và năm
      : data2?.userManage?.monthlyWatchTime || 0;
    const canWatchVideo = isMonthlyWatchTime > 0;
    // const isMonthlyWatchTime= data2.userManage.monthlyWatchTime + data2.userManage.extraWatchTime;
  return (
    <div className=' flex-column'>
        <div className='row'>
            <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 mx-auto card WatchingVideoLeft d-flex flex-column">
                {canWatchVideo ? (
                  <WatchingVideoLeft id={id} isYearWatch={data2?.userManage?.extraWatchTime} isMonthlyWatchTime={isMonthlyWatchTime} />
                ) : (
                  <div className="alert alert-success text-center mt-3">
                    Hãy{" "}
                    <Link to="/login"><b>Đăng nhập</b></Link> hoặc{" "}
                    <Link to="/subscribePackage"><b>Đăng ký gói cước</b></Link> để sử dụng tính năng nâng cao xem Video bài giảng. Hoặc tiếp tục tải hoặc xem file PDF/QUIZ miễn phí trong phần 'Tài Liệu' bên dưới.
                  </div>
                )}
                <WatchingVideoLeftBot />
            </div>
            <NextVideo 
            // videoListId={data.video.videoListId}
            ></NextVideo>
        </div>
    </div>
  )
}

